import { Text } from '@trmediaab/zebra';
import { formatMoney } from '@trmediaab/zebra-utils';

export type Props = {
  value: number;
  round?: boolean | 'thousands';
  unit?: 'cent' | 'main';
  showCurrency?: boolean;
} & React.ComponentPropsWithRef<typeof Text>;

/**
 * A component for rendering currency values.
 */
const Money = ({
  value,
  round = false,
  unit = 'cent',
  showCurrency = true,
  ...props
}: Props): React.JSX.Element => (
  <Text.inline whiteSpace="nowrap" {...props}>
    {formatMoney(value, round, unit === 'cent', showCurrency)}
  </Text.inline>
);

export default Money;
